const champArray = [
  {
    name: 'Aatrox',

    matchup: 'Win',

    runes:
      'depending on how good the aatrox is, 3 if im confident or 1 with conq or if im tilted or im playing against pro player and im scared i go 1',
    items:
      'D-Shield + exe+ Trinity or sund if youre behind or pussboy + hullbreaker or steraks + situational ',

    difficulty: 'Easy',
    comment:
      "Aatrox is an annoying champ for the first few levels hence the reasoning behind d Shield  and second wind. If the player is good he will zone you out waves but when you hit level 6 along with executioners which you should get first or second back (if you get 700g first back might aswell get sheen) you get full prio and win every time with ghouls and maiden, stay behind your ghouls to prevent getting hit by his W and use your W when he E's or use W to get short Grasp Q trades if he keeps holding onto E. dont run straight at him, make sure to dodge his easiest Q which is the first one, the runes help since you have approach vel",
  },
  {
    name: 'Akali',

    matchup: 'Skill',

    runes: '2 - but with second wind',
    items: 'D-Shield+ Trinity +  hullbreaker or steraks + spirit visage',

    difficulty: 'Medium',
    comment:
      'Akali, espcially a good one is very annoying in the early game hence the reasoning behind d sheild and second wind. If you get hit by her Q in the early game dont let her proc the AA empowerment. survive the early game and rush mercs if shes bad you may not have to, usually you can tell if theyre bad if they trade horribly in the early game and what elo youre in,(masters+) akalis are good (d2 below) tend to be bad. Lane trades should be landing your E with 3/4 ghouls AA Q walk away. When you hit 6 you can pressure all ins. Use your W only when she uses E or use the W if you think it helps land your E since its very important here. if she has electrucute and ignite this lane actually becomes hard since she will 100% burst you level 6 if you dont build MR but luckily most akalis dont do this since they dont know its a secret counter to us ;)',
  },
  {
    name: 'Akshan',

    matchup: 'idk',

    runes: 'idk',
    items: 'idk',
    video: 'https://youtu.be/dQw4w9WgXcQ',
    difficulty: 'idk',
    comment:
      'how about you figure if out yourself instead of needing to be babysat 24/7 :)',
  },
  {
    name: 'Camille',

    matchup: 'Skill',

    runes: '5 but you can go grasp if you want',
    items:
      'D-Blade + Trinity or sund if youre behind  + hullbreaker or  steraks + situational ',

    difficulty: 'Hard (if she goes grasp)',
    comment:
      "Camille is a weird one, without grasp she feels ok 1-6 but if she is running the resolve tree (they do 99% of times) shes very fucking annoying. One big thing you need to know is to block her hookshot all you need to do is W her and run into the W infront of her this casues her to E straight into you. this allows you to win 1v1s level 6 onwards with maiden and ghouls but even then its sometimes risky if she goes grasp. you win easily with trinity titanic and armour boots. Early game just do short trades like aa grasp Q or E AA Q with 3-4 ghouls and try not to get hit by her empowered Q wait it out before you go in for trades early game.Tell your jungler you have no prio pre level 6 and just chill in lane imo PSA: Most camille's in low elo are shit so dont be suprised if the lane goes better than thought ",
  },
  {
    name: 'Cassiopeia',

    matchup: 'Skill',

    runes: ' 3, 1 or 4 - with second wind and magic resist',
    items: 'D-Shield or corrupting + Trinity +hullbreaker or steraks + visage',

    difficulty: 'Medium',
    comment:
      'Can be very easy but also can be hard if the cass is pretty good espcially if she has those good ap items riot love so much! level 3-5 you can do decent trades to even all ins if you can land your E with 3-4 ghouls and then W go next to her AA Grasp Q she will lose like 60-80% of her health. Level 6 be careful if you can dodge her ults in all ins you win everytime unless she ofc has those lovely ap items riot loves! (liandries) dont forget your merc treads. I like buying those early unless I go glacial build then I would rush stridebreaker and just do big trades (not all ins) till I get ironspike whip ',
  },
  {
    name: "Cho'Gath",

    matchup: 'Win',

    runes: '1 or 2  or 3- can use boneplating or second win',
    items:
      'Corrupting or D-Blade + divine sund + hullbreaker or  steraks + situational  ',

    difficulty: 'Easy',
    comment:
      "Pretty damn easy, hard to mess up unless you forgot to track jungle and get spam ganked. You win at all stages in lanning phase apart from level 1 if he starts E. You can even do the typically Land E 3-4 ghouls land W AA grasp Q till he dies trades in pretty big waves and get away from it. Make sure you dodge his Q which is pretty easy with apporoach vel, they usually panic Q when you land E and W so its easy to predict. Level 6 he will eat maiden always keep her behind you with ghouls as back up so when he tries to eat her you bang him up. If he's full ap cho be careful he can kill you in one rotation with ult if he lands everything and E AA's you a few times with ult but he will be very squishy so if you start the all in you will win most of the time ",
  },
  {
    name: 'Darius',

    matchup: 'Skill',

    runes: 'can use 3 or 1 with conq instead ',
    items: 'Corrupting + Trinity +hullbreaker or  steraks + situational',

    difficulty: 'Medium',
    comment:
      'As of currently writing this darius can use stridebreaker to jump over yorick wall so be careful of that. When it comes to level 1 DO NOT GET CHEESED thats one way to hard lose. be hesisant before you go to the first wave, darius can be waiting on any of the bushes and if you leash red do not walk through tri bush go around. you can just afk farm till level 6 and start winning trades or you can do trades level 4-5 if you have 4 ghouls land E and use W. MAKE SURE to walk into him when you W him so he doesnt hit you with his Q. IF the darius is good he will 100-0 you with ghost flash vroom vroom mode if you miss your W so be careful. If you can land everything walk into him and dodge his Q while him being trapped with maiden and 4 ghouls you will win all ins . You will hard win with 2-3 complete items as long as you dont get hit by his Q more than once. you may need exe in this matchup but not early lanning phase. ',
  },
  {
    name: 'Diana',

    matchup: 'Win',

    runes: '1 with magic resist runes or 3',
    items:
      'Corrupting or D-Blade + hullbreaker or  Trinity + Deadmans or grudge if you are not behind',

    difficulty: 'Easy',
    comment:
      "Haven't really played this matchup this season, only saw it once in s10 and it was pretty easy. you can land abilites on her easily and its easy to stick to her. When shes 6 respect her if you dont have ult otherwise you should win all trades unless she somehow gets fed roaming or something. Make sure to keep yoru cs per min high she can be dangerous if shes out leveling and farming you.",
  },
  {
    name: 'Dr. Mundo',

    matchup: 'Win',

    runes: 'can use page 1 or 2',
    items:
      'Coruptting + divine sund +hullbreaker or steraks + grudge+  steraks',

    difficulty: 'Easy',
    comment:
      'idk have not played against new mundo, I know you will beat him 6+ tho once you have exe and maiden + ghouls',
  },
  {
    name: 'Fiora',

    matchup: 'Skill',

    runes: 'I like 5 but you can use 1 or 2',
    items:
      'Corrupting or D-Sheild+ sit on executioners + Trinity +  hullbreaker or steraks+ situational',
    video: 'https://youtu.be/JZ1k7ogFp4c',
    difficulty: 'Medium',
    comment:
      'I do list this as medium but if you play against her a few times and get use to it, it does become easy unless youre a playing against a good fiora which you wont find till gm+ although there may be a few good ones lingering in masters and diamond. Level 1 you want to be playing around your grasp procs and her vitals. if you know shes gonna attack you always trade back with Grasp Q and retreat to your wave while attack moving you will win these trades. Level 2 play safer since shes stronger whenever you hear her E sound dont bother trading. You want to get exe first back but if youre forced to back early and only have 700 get sheen instead. if you have less gold you might have limit tested a bit too much or got ganked just go cloth armour or long sword. When youre 6 you want to be  the one engaging. you can do fast the combo (E + AA + Grasp Q) and back off that will take 50-70% of her health and you can pressure to kill from there. Try not to fight when youre both 100%, you miss  E and she has parry she will tend to win these all ins unless you are fed. You want to be kitting her when you all in her. refer to my video to see how all ins work, although its a s10 vid its still applies here. I like going exe > bramble here since exe got a buff while the price got cheaper. Bramble is pussboy item.  Yes I did build bramble in the vid but its was s10',
  },
  {
    name: 'Gangplank',

    matchup: 'Win',

    runes:
      'you can use any rune page here its rly pref but make sure you take second wind if you go resolve tree',
    items:
      'D-Shield or Corrupting if its low elo + Trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks + Rav or Titanic its pref here',

    difficulty: 'Easy',
    comment:
      "This matchup is easy but it can be diffcult if you play against a really good gp, I played against armut's gp with the wrong setup and it was a nightmare. if you are playing against a challenger or pro tier gp MAKE SURE YOU COPY MY EXACT RUNES AND STARTING ITEMS. Otherwise its fine you can even go cpot and destroy most gps, level 1 build up grasp go for stacking or if he gets too close grasp q him. Make sure to stand in your wave level 1 so he gets aggro when he does the grasp Q zzz spamming. level 3-5 you can try all ins if the wave is next to your tower. you have kill potential from level 3 as long as you have ghouls set up. I like using rune page 1 but some of these pirates are slippery so rune page 4 can help ",
  },
  {
    name: 'Garen',

    matchup: 'Win',

    runes: 'you can use 1, 2 and 3. I like 1 and 2 here',
    items:
      'D-blade or Corrupting + Trinity + hullbreaker or steraks + titanic or  grudge if you are not behind',
    video: 'https://youtu.be/V8Pc0iD6A30',
    difficulty: 'Easy',
    comment:
      'Pretty easy just dont get hit by his Q continously level 1 like a idiot. Dont use W when he is spinning since he is masking his spin with Q so he gets movement speed to its hard to hit but it can be easier if you land your E and have approach. if he has ignite dont fight him when he ignites you. If they intend to kill you they usually initate the ignite before they ult. Once you hear the ignite tick retreat unless youre confident you will kill him in one rotation. You win most all ins if you start the engage with maiden and ghouls so be a man and run thim down. vid is s10 but same concepts apply',
  },
  {
    name: 'Gnar',

    matchup: 'Skill',

    runes:
      'You can use any rune page its playstyle pref but I like using 5 here',
    items:
      'D-Sheild + Trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks + titanic',

    difficulty: 'Medium',
    comment:
      'Riot has a fetish with constantly buffing this pos so I can see him being annoying soon. His a range champ so yeah typically annoying early game. you just want to play passive and go for quick short E > AA grasp Q trades with ghouls in lanning phase. Never use your W until he hops. Level 6 you can full prio but he can kill maiden pretty easily from range I usually shove wave then back and position my maiden behind me because of this. Gnar players are usually pussboys so they are hard to kill unless for some reason they jump into you. Rune page 4 with stridebreaker can lead you to more kills since it slows them enough for you to bonk them',
  },
  {
    name: 'Gragas',

    matchup: 'Win',

    runes: '1, 2, 3 or if youre feeling spicy 4',
    items:
      'cpot or D-Sheild + Trinity +hullbreaker or steraks + titanic + grudge',

    difficulty: 'Easy',
    comment:
      'The main danger is him ulting you behind his tower so be careful of that. You can poke him with grasp q level 1. respect his W when he turns purple dont attack him unless you have to. of course dont get hit by this Q. Only use W when he uses E. level 1-4 you can do good trades and even get kills. you get perma prio 6 onwards',
  },
  {
    name: 'Gwen',

    matchup: 'Skill',

    runes: '6 or 1',
    items:
      'cpot or D-Sheild + exe + Trinity + hullbreaker or steraks + titanic + situational',

    difficulty: 'Medium',
    comment:
      'like new tahm kench I have not played against gwen much because she came out when Im taking my year off league vaccatine. play passive level 1-6. When she does a full engage with her E thats your time to back off unless you are ahead. if she uses W dont go all in only do short AA+ Q trade. only use W when she dashes in or out. when you both have ult use your intuition but you have to commit if you want to kill her. since I dont have much experience i just back off when she presses R once unless shes clearly going to lose and re engage after.',
  },
  {
    name: 'Heimerdinger',

    matchup: 'Skill',

    runes: 'i pref rune page 3 with second wind ',
    items: 'D-Sheild + Trinity + hullbreaker or steraks + titanic',

    difficulty: 'Medium',
    comment:
      'This lane is annoying because its heimer. You can kill him in lane but you need to be careful with his turrets. the lane will be perma pushed in you just need to farm under tower with d sheild, when youre 6 you can send your maiden and 4 ghouls box him + 1 AA + Grasp Q and let your wife and ghouls do the work you dont want to stay next to him for long since he will have ult turret and that does DMG. this combo should force a flash and get him very low. make sure you get magic mantle early game first or second back',
  },
  {
    name: 'Illaoi',

    matchup: 'Skill - Yorick favoured ',

    runes: '1 ,2 oe 3. I like conq here but grasp is good',
    items:
      'D-Blade or Corrupting + Trinity + hullbreaker or steraks + titanic or  grudge if you are not behind',
    video:
      'https://youtu.be/TtkXBc_QgHM?list=PL7nrRETkphkeE5VH6kyZ7y5-jD4MvEdyJ',
    difficulty: 'Medium',
    comment:
      'This can be a hard matchup if you get hit by every E she throws. level 1-3 you want to stack up ghouls and once you have 4 ghouls go for all ins. make sure you are always behind the ghouls so she doesnt land her E (ghouls block it) the video attached is a perfect example how to do it. its an s10 vid but the premise if the same its just the build is slightly different. make sure to get exe at some point in lanning phase since she builds that balanced item. goredrinker',
  },
  {
    name: 'Irelia',

    matchup: 'IMPOSSIBLE DONT DO IT',

    runes: '1, 2 , 3, 4 , 5 pick your poison',
    items: 'D-Sheild or corrupting + Trinity + hullbreaker or steraks',
    video: 'https://youtu.be/HoLhSQU_MMY',
    difficulty: 'RUN',
    comment:
      'BUSTED ARSE CHAMP REEEE. You use to realiably outscale her 2-3 items now thats not guaranteed. Best bet is freezing wave near your tower if she freezes at her tower you better spam for jungle help or roam. AND DONT TELL ME YOU CAN BEAT HER IN YOUR PISSLOW SILVER GAME SHES HARD OK. dont forget anti heal',
  },
  {
    name: 'Jax',

    matchup: 'Lose',

    runes: 'I like 5 here but you can run grasp ',
    items: 'D-Blade + divine sund+ hullbreaker + titanic',
    video: 'https://youtu.be/G6AcWTfZX8Q',
    difficulty: 'Hard',
    comment:
      'Jax is tricky but no where near as bad as irelia, still annoying probs the 2nd hardest counter. Level 1 you want to bait out his E he will E the wave and you which will cause all minions to aggro make sure you fit in a AA grasp Q in retaliaition everytime he does this without walking into his wave. If he has pea brain he will stand still and just AA with the wave attacking him, you want to attack move kite more into your wave towards your tower if he does this you will chunk him big time. when his about to hit level 2 (when he has 7cs exp) you want to back him and just let him push, when you hit level 2 farm with E hit him when you can but dont think about big trades he will win level 2. level 4-5 he might want to trade with you HOLD YOUR W till he jumps into you and kite backwards landing E, He will jump into you with E. once his finishes wack him with AA + grasp Q proc and keep wacking him if his in your wave. keep doing this the whole lanning phase. level 6 make sure maiden is always behing you. he might get annoyed and try to all in maiden. if he does this and you miss your E and you have no ghouls near by say bye to maiden because you wont be able to do shit. you can beat jax with short trades like i prior explained or all ins if he jumps and on maiden and tries to kill her while you have 4 ghouls and E. its all about kiting and aa moving with jax never stand in one position and go for a blow to blow compeition you wont win those. The vid linked is a bit outdated but the concept I covered here is used in it ',
  },
  {
    name: 'Jayce',

    matchup: 'Win',

    runes:
      '1 or 5 with second wind but you could use 4 if youre struggling to hit him or 3 if youre confident',
    items:
      'D Sheild or corrrupting  + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'Although the matchup is easy jayce is still a ranged champ so dont disrespect his early game level 1-3, you want to just be farming and setting up graves then you can go for big trades which you will win as long as you land E and W with Q thrown in there. also make sure youre not doing this in a big enemy wave in the early game. you win all the all ins unless he starts it and you miss everything and have no grave setup. its a natrual counter all pros know so yeah nice matchup here. ',
  },
  {
    name: 'Kalista',

    matchup: 'Skill - Heavily kalista favoured pre 6 without items',

    runes: '4,5 or 1 make sure you have second wind',
    items:
      'D sheild + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks',

    difficulty: 'Hard',
    comment:
      "People that play kalista top are glue sniffing mouth breathers, if she has hail of blades say bye the the first wave, start E level one sit back she will hard zone you early level you can't do anything about it. just sit under tower and try to cs. level 6 once you have items and armour you go land your E with maiden and 4 ghouls and teach the glue sniffer a lesson",
  },
  {
    name: 'Karma',

    matchup: 'Win',

    runes: '4 or 1 make sure you have second wind or 3 if youre confident ',
    items:
      'D sheild  or cpot + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks + grudge',

    difficulty: 'Easy',
    comment:
      'Karma top like all ranged top lanes can be annoying early, but not too bad when it comes to karma. You might want to go cpot to do heavy trades but in higher elo they will understand spacing and kiting so i would pref d sheild there. if you can land everything she dies or flashes. she can be slippery so the glacial + stridebreak combo can be nice here. just focus on stacking graves and look for big trades level 3-4, 6 onwards you always have kill pressure and prio. ',
  },
  {
    name: 'Kayle',

    matchup: 'Win',

    runes: 'could use 4 but I like 1 personally ',
    items:
      'D Sheild or cpot + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'If you asked me about the kayle matchup in preseason 11 I would say hard since she was turbo DoinB broken but now shes managable again, if she has pta she might try cheese kill you level 1 which wont work if you go with grasp option just bonk her and auto attack weave into your wave. Shes a slippery champ so glacial + stridebreaker is nice her since once you lock her down its free kills or flash burnt. if she ults while in W dont walk into her or waste Q her ult aoe does hurt so respect it. you have kill pressure level 3 till the end of lanning phase. level 16 kayle does become problematic, land your abilities go for quick short trades with Q maiden and ghouls, kinda like what Ali did to Liston or sugar ray lenoard vs duran 2  watch those fights to get an idea',
  },
  {
    name: 'Kennen',

    matchup: 'Win',

    runes:
      'you can use 1 2 3 and 4, I would use 1 or 4 depending on how I feel on landing skillshots',
    items:
      'D Sheild or cpot + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'Easy lane similar to karma except his a lot more mobile, its really annoying when he turns into lightining and goes brrrrr out of there. Can be easier to lockdown with glacial and stridebreaker. you can go for big trades level 2-5 and when youre 6 you get full prio and even more kill pressure. really isnt a problem, if he ever engages you win unless jungler comes ofc. JUNGLE DIFF. make sure to use W in teamfights only for him if you see him about to enagage since it can be game changing.',
  },
  {
    name: 'Kled',

    matchup: 'Skill',

    runes: '2 you can use 1. 3 can be used but be careful early game',
    items: 'D Sheild or corrupting + divine sund +hullbreaker or steraks',

    difficulty: 'Hard',
    comment:
      "He wins lane and can even dive if you play it badly pre 6. you can do short trades but if you do dismount him pre 6 with no items. DO NOT TRY TO KILL HIM ALONE. I REPEAT DO NOT TRY KILL HIM. ITS A TRAP. you cant burst him fast enough he will mount and eat you alive. you do hard outscale him with trininity tabis and exe so once you have those items and he isnt too ahead force enagage with maiden and 4 ghouls, dont use W unless he E's and fight him, learn how to aa weave dont let him hit you with his W. pref fight when his W is on cd and he misses Q those are the best times to all im. ",
  },
  {
    name: 'Lucian',

    matchup: 'Skill',

    runes: '4, 2 or 1 make sure you pick second wind whichever you pick',
    items:
      'D Sheild or cpot + trinity or use stridebreaker if you use page 4 rune +hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      'Annoying fella in the early game, let him push it towards you be next to your wave or slightly behind it so when he attacks you the minions attack him and it will push eventually to you. can go for short trades if the wave is near your wave and you have graves. land E > AA > Q and use your W if he dashes otherwise weave in autoattacks and back him when he runs way and let ghouls some action. Level 6 onwarsd if you have stridebreaker and glacial with maiden you brrrr run him down. with grasp its harder since you have to land E but you can do the same thing',
  },
  {
    name: 'Malphite',

    matchup: 'Win',

    runes: '1 or 2 make sure to take second wind',
    items: 'D sheild or cpot + divine sund + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'ROCK SOLID. hate when he spamms Q but you have d sheild and second wind so it wont be that annoying. its similar to cho but his just more annoying, get graves setup poke with grasp q when you can and do short trades with ghouls e > aa > Q and ofc have him trapped. if he activates W just walk off, keep attacking him to keep his passive off. you have kill pressure 4 onwards but he does have ult so its hard to kill him if he has that up. focus on getting huge cs lead and grasp procs if he plays like pussboy. ',
  },
  {
    name: 'Maokai',

    matchup: 'Win',

    runes: '1 or 2 can use boneplating but make sure you take unflinching here',
    items: 'D sheild  or cpot + divine + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      "Havent seen this guy in s11 nor after early s10 heard his enjoying his vaccation in the botlane. its an easy lane if you use W run into him like a darius so when he W's you his still stuck. you cant lose to him 1v1 if you do please message me on discord I would like to see how badly you played it. ",
  },
  {
    name: 'Mordekaiser',

    matchup: 'Skill',

    runes: '3 or 6',
    items: 'cpot + trinity or sund if you are behind  + hullbreaker or steraks',
    video: 'https://youtu.be/6eFVep4DlAE',
    difficulty: 'Medium',
    comment:
      'Not gonna say much since the video I linked explains everything although its an s10 vid it still applies here when it comes to trading, you can win all ins level 2 with conq and 4 ghoul setup if you land E. gonna need anti heal at some point but not too early in the game I like rushing mercs some people go qss which is fine since now qss builds into a decent item. before it didnt so I was against it. Otherwise if you have big balls you can use your W to kite around him when youre in his ult, theres many examples of doing this on my last montage I did https://youtu.be/0tlHzLtQ7PU',
  },
  {
    name: 'Nasus',

    matchup: 'Skill',

    runes: '3 or 6',
    items:
      'cpot or d-blade + Trinity  or sund if you are behind + hullbreaker or steraks',
    video: 'https://youtu.be/3M4j_EEOCQ4',
    difficulty: 'Medium',
    comment:
      'This lane is hard in the sense that youre on a time limit. you have to abuse his early otherwise he scales quick and runs you down if youre not prepard. it use to be easier in s10 but now its harder (thanks riot) you want to keep the wave next to you or at the center early level. level 3 you want to all in when his about to stack the cannon with graves. he will die or flash. you want to freeze the wave near you and go for big trades. always make sure you land W otherwise he runs you down. the vid linked shows how to play it early game although it is s10 it still applies here. ',
  },
  {
    name: 'Neeko',

    matchup: 'Win',

    runes:
      '4 with second wind or take 2 with unflinching and second wind. dont forget magic ressist ',
    items:
      'D sheild  or cpot + trinity or use stridebreaker if you use page 4 rune + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'This is like karma lane very easy. if you mark her with E and she uses W you can see the real one since she will be marked which makes this lane even easier, she can be slippery so glacial stridebreaker is really good here. ',
  },
  {
    name: 'Olaf',

    matchup: 'Skill',

    runes: '1,2 , 3 or 6',
    items: 'Cpot + Trinity + hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      "Treat his level 1 like a darius, be causious he can all in level 1 and run you down so stay back and chill. you'd think olaf falls off but with s11 he scales good now! (thanks riot) you can still win trades level 6 with exe, get him below 50% health before all ins so you can kill him in one rotation without him healing. if you have tri with exe you can all in kill him but you need to learn how to kite dont just stand in one spot.",
  },
  {
    name: 'Ornn',

    matchup: 'Skill',

    runes: '2 or 1 make sure to take magic ressit and second wind',
    items: 'D-Sheild + sund + hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      'Ornn is annoying since he can spam Q but he isnt too hard, make sure you dont get hit by his brittle. you need to learn how to auto attack weave. land E with ghouls dont use W till he presses E auto attack grasp Q. need to run in and out smilar to what I said on the kayle one when shes 16, refer back to Ali vs liston or leonard vs duran 2. He does a ton of ap dmg and can actually one shot you level 6 So i pref to have kindlegen and sheen before I all in or if theres an ap jgl i rush mercs ',
  },
  {
    name: 'Pantheon',

    matchup: 'Skill',

    runes: '2 boneplatting and unflinching important here',
    items:
      'D- Sheild + Trinity or sun dif you are behind  + hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      "Start E and use that to farm, let him push wave in with Q. if he has empowered Q dont get hit by it. if you have boneplating you can bait him to use q while hitting your minions so it pushes towards you. once youre 6 you can win all ins just land E and W with maiden and 4 ghouls if he E's run behind him and say ",
  },
  {
    name: 'Poppy',

    matchup: 'Win',

    runes: '1,2 3 or 6',
    items: 'Cpot + divine sund + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      "Go for Q grasp procs and set up graves level 1. level 2 you can go for short AA > E > Q trades, level 3-5 do the same thing except have W so you can go for extra AA's if you trap him. try to not get hit by her grasp sheild thing she throws at you and dont stand next to walls, if youre at the tower try to stand furthuer back deep  in the tower so if she does E she will take a tower shot. you win all ins  with maiden its not close if you land everything",
  },
  {
    name: 'Quinn',

    matchup: 'Skill',

    runes:
      "4 if you feel like you can land your skillshots easily go 1. Don't forget second wind",
    items:
      'D sheild + trinity or sund if you are behind +hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      'Same as lucian shes annoying except more annoying since she can jump out of your W, if you trap her try to position in front of her so she flips onto the W instead of away, if you have glacial + stridebreaker its harder for her to run but you need to play safe till you get ironspike whip min before you want to do big trades.',
  },
  {
    name: 'Renekton',

    matchup: 'Skill but renekton favour if he knows what he is doing ',

    runes: '2 you can use 1 or 3 if youre very confident ',
    items:
      'D-Sheild or Cpot + divine sund or trinity if you are ahead + hullbreaker or steraks',

    difficulty: 'Hard',
    comment:
      'You outscale him with 1 and a half items with exe and tabis but lanning phase is annoying. dont bother stacking too many graves his gonna autopush towards you, just last hit and hit him with grasp Q, play around his rage and cds in this lane. lets say he does a full combo and his rage is on cd thats your time to go in for a big trade use everything. you need to learn how to weave and kite here. like land your E with ghouls grasp Q and run off if tries to e in W and aa > grasp Q and kite backwards. if he ults you kite backwards while attacking him.  rush tabis in this matchup, you wont really kill him in lane unless he really messes up or you get jungle gank, just focus on farming and hard ouscaling him',
  },
  {
    name: 'Rengar',

    matchup: 'Skill',

    runes: '3  or 6 (dont go grasp here ever imo)',
    items: 'D-Sheild or Cpt + trinity + hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      'Level 1 you get hard zoned from wave you sit back and cs with E, survive till you get maiden and get deep wards so he doesnt roam. when you have maiden + exe + ghouls you all ins if you land E. dont use W in bushes as he jumps out of it pretty easily. only use it if he isnt in bush. get pink wards and ward the bush before you all in later on in lane. ',
  },
  {
    name: 'Riven',

    matchup: 'Skill',

    runes: '1, 2 or 3. I like using 2 or 3 here',
    items:
      'D sheild or cpot + trinity or divine if you are behind + exectioner if she goes gore drinker+ hullbreaker or steraks',
    video: 'https://youtu.be/ZfArN7tSZTQ',
    difficulty: 'Medium',
    comment:
      'Level 1 focus on stacking graves and go for grasp procs if its free dont do it if shes in her wave and she has q ready. you play around rivens cd to beat her e.g. she just q combo the wave to clear it? go for quick e aa grasp q trade. you win trades by weaving and kiting around her cds. video attached shows basic how to play against riven although its s10 stil appllies respect her level 6 she can all in and kill if she try to combo in disengage e run back q aa when she finishes her combo run back in maiden ghouls and run her down. dont forget to build exe against riven since she builds that balanced item! GOREDRINKER!',
  },
  {
    name: 'Rumble',

    matchup: 'Skill',

    runes: '2 take second wind important here and magic resist',
    items:
      'D- Sheild + Trinity or divine if you are behind + shullbreaker or steraks)',

    difficulty: 'Medium',
    comment:
      'He has some secret power in the early game and level 6 no one ever respects it but be careful. I pref doing short trades in lanning phase never 100-0 if he has ult unless you are fed and he misses everything? he is annoying af early game and might even get you very low dont get disheartened it happens you can beat him tri and merc if you land everything and all in with maiden and ghousl ',
  },
  {
    name: 'Ryze',

    matchup: 'Win',

    runes: '4 or 2 up to you',
    items: 'D sheild  or cpot + trinity +hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'Pretty easy if you land W you just run him down, he is hard to catch which is why i suggest glacial stride as an option, not much to say you can run him down with ghouls and respect his level 1-4',
  },
  {
    name: 'Sett',

    matchup: 'Skill - very annoying laning phase borderline hard',

    runes: '2 or 3, I like 3 here + Take boneplatting',
    items:
      'D sheild + Trinity or sund if you are behind e.g. behind 20+cs or kills +hullbreaker or steraks',
    video: 'https://youtu.be/D0bNpt1svuQ',
    difficulty: 'Hard',
    comment:
      'I hate this champ. use e level 1 and just farm in this lane you can reliably fight with with items and exe, play around cds. if he uses e or w for no reason go in and fight and if you have maiden you could all in if he has w on cd. if he targets maiden its hard to do anything if he has bork since he will kill maiden in 3 auto attacks (thanks riot!)',
  },
  {
    name: 'Shen',

    matchup: 'Skill',

    runes:
      'I like taking 1 but with conq instead and legen tenacity since lane is always stale as most shens are pussboys ',
    items: 'cpot or d-blade + sund + hullbreaker + titanic',

    difficulty: 'Medium',
    comment:
      'I have a personal grudge with this champ. he doesnt do shit and has a winning team everytime!! ok enough with rant you just chill early game go for short trades but dont bother you wont kill him unless his an idiot. level 6 you gain full prio but you wont kill him unless he overextends or does something dumb which is common in low elo. otherwise keep shoving waves get cs leand and plates. Use edge of W to cancel his ult if he ever does ult ',
  },
  {
    name: 'Singed',

    matchup: 'Win',

    runes:
      'any rune page, pref playstyle I like going 4 if I think i wont land anything but if i can land abilities any other page',
    items: 'D sheild + trinity + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      "Don't really need to say much you just win? just respect level one since he will shove and get 2 then flip you other than that how do you die to this guy unless you play like idiot?",
  },
  {
    name: 'Sion',

    matchup: 'Win',

    runes: '1 or 2 either is fine',
    items: 'Cpot + divine sund +hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      "I've only played against 2 players that made this a skill matchup but the majority of sion players aren't that good. Level 1 focus on stacks and level 2 just get cs and grasp q stacks on sion. level 3-5 go for big trades, such as E>Q> W>AA>Q  your wall can block sions ult and you can cancel his q cast with it if you use the edge of your wall. Usuall in lanning phase you have kill pressure 3 onwards but be careful of the jungler. when you trap him dont just run head first wait for his Q cast and then run behind him and start bonking",
  },
  {
    name: 'Swain',

    matchup: 'Win',

    runes:
      "1, 2  or 3. Haven't played against him for a while but I think either of these choices are fine ",
    items: 'D sheild  or cpot + exe +  Trinity + hullbreaker or steraks',

    difficulty: 'Easy',
    comment: 'Who the fuck plays this champ, idk build exe and win all ins',
  },
  {
    name: 'Sylas',

    matchup: 'Win',

    runes: '1 or 2, maybe 3 if you really like conq',
    items: 'cpot or d-blade +exe+ Trinity + hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'Stack ghouls level one, your grasp Q HURTS HIM hard early level be sure to do it if you have a chance. force him to fight you and kite backwards once he jumps in go and all in. you will win all in if you survive his intial burst. his a pretty easy lane just dont get poked too hard by his q and force big trades with ghouls and all ins with maiden.',
  },
  {
    name: 'Tahm Kench',

    matchup: 'Skill/hard till he gets nerfed as of wiriting this on 21/08/2021',

    runes: '3 or 6',
    items: 'cpot or d sheild + divine sund+ hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      "new tk is harder than old, I've only experienced this matchup twice as you know I dont play league rn. level 1-5 I pref to not risk it and play passive till i get maiden then I'll make long trades and back off once wall breaks while kiting backwards until he gets low enough to kill him within 2 rotations of using all my abilities. You do outscale him hard within 2-3 items so you can play for that aswell. play safe if you are next to his tower as he will eat you and spit you under tower and ofc thanks to maiden you will draw tower aggro!",
  },
  {
    name: 'Teemo',

    matchup: 'Skill',

    runes: '4 or 2,5  if you want to do normal build',
    items:
      'D sheild  or cpot + trinity or use stridebreaker if you use page 4 rune +hullbreaker or steraks',
    video: 'https://youtu.be/v_ECNgTt8Mc',
    difficulty: 'Medium',
    comment:
      'Little shit gives me vietnam flashbacks mid-late game, respect early game ofc his range and ap it hurts. if you struggle locking him down go glacial stridebreaker and sit on negatron cloak. whenever you trap him in w with ghouls and maiden its free kill. get sweeper or pinks to avoid ptsd',
  },
  {
    name: 'Trundle ',

    matchup: 'Skill ',

    runes: '1 maybe 3 if you have conq fetish ',
    items: 'Dblade + exe+ trinity +hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      "He will win all ins once he ults you so kite him as soon as he r's you. early game go for short trades unless you land everything with W you can AA a few times with grasp Q. if you poke him down enough early game you can try kill him. respect his level 1 and 2 ",
  },
  {
    name: 'Tryndamere',

    matchup: 'lose',

    runes: '2 can do 1 but its balsy pref 2 with offtank titanic build',
    items: 'D sheild or cpot + sund + hullbreaker+ randuin',

    difficulty: 'Hard',
    comment:
      "Respect the level 1 he will e beyblade spin up your arse let him push the wave and try to hold the minions till your wave comes in a bit to get a small freeze near the tower, never use W unless he E's learn how to weave and kite or you will lose since you cant just stand still and use abilitles. you dont exactly win but you can get get tanky enough where you can get him low and use his ult then kite him till it runs out. this usually happens when you have tri deadmans and titanic with tabis. ",
  },
  {
    name: 'Urgot',

    matchup: 'Skill',

    runes: 'i pref 3 but you can use other pages ',
    items:
      'Cpot or d-blade + exe if he goes conq goredrinker+ Trinity or sund iff you are behind  + hullbreaker or steraks',

    difficulty: 'Medium',
    comment:
      'Respect his level 1 if he started e, if you let him e you, you will lose 50% of your health. just farm and chill till level 4-5 then do nice short trades, if he uses E in your W go for long trades, with conq you can kill him. make sure you trap him land e but dont use ghouls straight away as he can shoot them down with W, aa grasp q then activate. get exe 2 or 3rd back since he goes goredrinker. use ult and poke him one rotation at a time, 100-0 all in is kinda dangerous if he uses ult so getting him low first is good',
  },
  {
    name: 'Vayne',

    matchup: 'Skill - more yorick favoured',

    runes: '1 2 5 or 4, I like 4 since sometimes I struggle landing abilites ',
    items:
      'D sheild  or cpot + trinity or use stridebreaker if you use page 4 rune +hullbreaker or steraks',

    difficulty: 'Easy',
    comment:
      'Annoying level 1 2 and 3 but you can do good short trades if you land everything. I tend to miss allot on vayne players so I like going glacial stridebreaker so I can land my abilities allot easier. if you trap her in with everything landed shes dies, flashes or losses 70%+ health. you need to land w if she ults otherwise she shoots your arse down',
  },
  {
    name: 'Volibear',

    matchup: ' Skill - early lane is slighly voli favoured',

    runes:
      '1 2 or 3 take second wind he procs boneplatting to easily. unflinching is nice here',
    items:
      'D sheild or cpot +exe + sund + hullbreaker or steraks+ situational ',

    difficulty: 'Medium',
    comment:
      'He is scary bear early game but dont worry you outscale him once you have maiden and ghouls along with exe. respect early game only go for short trades you wont win long trades since he has W. he heals off W and bites half your health off. you can do the short E> Q> W > AA > Q run trade ',
  },
  {
    name: 'Vladimir',

    matchup: 'Win',

    runes: '3 or 1 with conq instead of grasp',
    items:
      'cpot or D-Sheild +exe + Trinity + hullbreaker or steraks+ situational ',

    difficulty: 'Easy',
    comment:
      "Pretty easy but his range so respect his level 1 and empowered Q's you win all ins hard with maiden and ghouls, get exe 3-4th back. dont try to do all ins level 2-4 when theres a big wave it dont work too well but you can do big trades and get like 60%-80% of his health",
  },
  {
    name: 'Viego',

    matchup: 'Skill',

    runes: '1, 2 or 3',
    items:
      'cpot or d sheild +exe+ trinity + hullbreaker or steraks+ situational',

    difficulty: 'Medium',
    comment:
      'only played against 3 times will update once I get better understanding. You hard win with maiden and ghouls if you can land E and W. He cant dash out of W unless he ults. I pref rune page 1 since it allows me to run him down quicker. Watch out for his early levels its comparable to a panth but slighly easier. You should win short trades level 4-5 with ghouls. You lose level 1-3 trades. When he goes invis its not akalis you can follow his path and see him. ',
  },
  {
    name: 'Warwick',

    matchup: 'skill',

    runes: '3',
    items:
      'd sheild +exe+  trinity or sund if pussboy  + hullbreaker or steraks+ situational ',

    difficulty: 'Medium',
    comment:
      'warwick is a cheesy laner but you can outscale him with 1 components and 1 item. you need to rush exe first back. go mr in runes since he does allot of ap dmg. never try to trade level 1-3 you dont win those unless his overly stupid. you want to hide behind ghouls and maiden when you all in so he doesnt ult you. once you have tri and exe you need to start the all ins with ghouls and maiden to win. whenever he presses e kite backwards wait for it to be on cd and walk back in. make sure you wall him and walk into him with maiden and ghouls with you. ',
  },
  {
    name: 'Wukong',

    matchup: 'Skill',

    runes: '2 or 1 with overgrowth unless they have many hard ccs abilities ',
    items:
      'D-Sheild or cpot +exe+ trinity + hullbreaker or steraks+ situational',
    video: 'https://youtu.be/eUcvxQECn9k',
    difficulty: 'Medium',
    comment:
      'Respect level 1 he spams E you need to kite backwards and use your grasp Q. GRASP Q HURTS THIS MONKEY since he has low mr and grasp q does magic damage. Level 6 if he ults dont stand still run backwards and use your W once he ults. once his ult is on cd run in with maiden ghouls and BONK HIM. you can do good trades 3-5 if wave looks favourable. If you have him marked and He W the mark dissapears on the clone so you know which one is the real one. ',
  },
  {
    name: 'Yasuo',

    matchup: 'Skill',

    runes: '3 or 6',
    items:
      'D sheild + exe+ trinity  or sund if youre behind + hullbreaker or steraks+ situational ',

    difficulty: 'Medium',
    comment:
      'Respect his level 1 and 2 let him push it. level 3-5 decent short trades dont try all in tho unless his trash he will does go brrrr and dash everywhere. level 6 maiden if you land e break his sheild and bonk with wiht AA you can win.  try W away from minions so he cant dash out our just run to the side of him and W. YOU NEED EXE HERE he heals allot with conq, ravenous and his item gives him lifesteal. I would get exe first,2nd or 3rd back dont delay it too much',
  },
  {
    name: 'Yone',

    matchup: 'Skill - Yone favoured early game',

    runes: '3 or 6',
    items:
      'D sheild + exe+ trinity  or sund if youre behind + hullbreaker or steraks+ situational ',

    difficulty: 'Medium',
    comment:
      'This guy is more annoying than yasuo imo. you need exe 2nd or 3rd back. He wins level 1-4 level 5-9 you can turn it around providing you have exe and sheen. dont use w unless he jumps out of his body. if youre low use W to block him off. go for short trades only early game. if he lets you poke him enough early game you could kill him',
  },
  {
    name: 'Yorick',

    matchup: 'Skill',

    runes: 'take whatever its norms so have fun',
    items: 'take whatever you want bby ',

    difficulty: 'Medium',
    comment:
      'I dont play normals and Im guessing youre better off winning the lottery then getting this mirror matchup. I  dont care and you shouldnt too just have fun bruv',
  },
  {
    name: 'Zac',

    matchup: 'Win',

    runes: '1, 2 or 3',
    items: 'cpot + trinity + hullbreaker or steraks +visage + situational',

    difficulty: 'Easy',
    comment:
      'build exe 2nd back, dont bother trading level 1 just stack graves. level 2-6 you win trades if you land e. you win all ins with maiden and landing e. Use W whenever he ults it denies him hard. save W for zac E (you can see where he lands easy) in teamfights ',
  },
]

export default champArray
